// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__EaGaV","paymentMethodSection":"styles_paymentMethodSection__3_UBB"};